import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { auth } from '../../firebase';
import * as routes from '../../routes/routes';
import { Paper, Button, TextField, Typography } from '@material-ui/core';
import { toast } from 'react-toastify';

const ForgotPasswordPage = ({ history }) =>
    <div>
        <ForgotPasswordForm history={history} />
    </div>

const updateByPropertyName = (propertyName, value) => () => ({
    [propertyName]: value,
});

const INITIAL_STATE = {
    email: '',
    error: null,
};

class ForgotPasswordForm extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown)
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown)
    }

    handleKeyDown = (event) => {
        if (event.key === "Enter") {
            this.onSubmit(event)
        }
    }

    onSubmit = (event) => {
        const { email } = this.state;
        const { history } = this.props;

        auth.passwordReset(email)
            .then(() => {
                toast.success("Password reset link has been sent to your email address! Please click the link to update your password", {
                    position: "top-center",
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    onClose: () => history.goBack()
                });
                this.setState(() => ({ ...INITIAL_STATE }));
            })
            .catch(error => {
                this.setState(updateByPropertyName('error', error));
            });

        event.preventDefault();
    }

    render() {
        const {
            email,
            error,
        } = this.state;

        const isInvalid = email === '';

        return (
            <div className="padding-middle">
                <div style={{
                    textAlign: 'center',
                }}>
                    <Paper className="papper-middle-smaller">
                        <TextField
                            label={'Email'}
                            required
                            onChange={(event) => this.setState(updateByPropertyName('email', event.target.value))}
                        />
                        <br />
                        <Button
                            disabled={isInvalid}
                            className="formButton"
                            onClick={this.onSubmit}
                        >
                            {'Send'}
                        </Button>
                        {error && <Typography className="message-error">{error.message}</Typography>}
                        <div style={{ flexDirection: 'row', flex: 1 }}>
                            <Link style={{ marginRight: '50px' }} to={routes.LOGIN}>Log in</Link>
                            <Link style={{ marginLeft: '50px' }} to={routes.REGISTER}>Register</Link>
                        </div>
                    </Paper>
                </div>
            </div>
        );
    }
}

const ForgotPasswordLink = () =>
    <Typography>
        <Link to={routes.FORGOT_PASSWORD}>Forgot Password?</Link>
    </Typography>

export default ForgotPasswordPage;

export {
    ForgotPasswordForm,
    ForgotPasswordLink,
};



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/index.js